import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';
import { UtilsService } from '../services/utils.service';
import { MyCompanyProductRoles } from '../models/my_company_product_roles.model';

@Injectable({ providedIn: 'root' })
export class MyCompanyProductRolesInitiatedGuard implements CanActivate {
  permissions = inject(PermissionsService);
  utils = inject(UtilsService);

  async canActivate(): Promise<boolean> {
    const my_company_product_roles = this.permissions.areCompanyProductUserMemberInitiated();
    if (my_company_product_roles != null) return true;

    const mprResponse = await this.permissions.fetching_my_company_product_roles;
    const myCompanyProductRoles: MyCompanyProductRoles | null = mprResponse;

    if (myCompanyProductRoles != null) {
      return await this.isMyCompanyProductRolesInitiated();
    } else return false;
  }

  private async isMyCompanyProductRolesInitiated(it: number = 0): Promise<boolean> {
    if (it > 5) {
      return false;
    } else {
      if (this.permissions.areCompanyProductUserMemberInitiated()) {
        return true;
      } else {
        await this.utils.sleep(100);
        return await this.isMyCompanyProductRolesInitiated(it + 1);
      }
    }
  }
}
